import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges, TemplateRef} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Notifications
import { HotToastService } from '@ngneat/hot-toast';
import { JobTypeCourt } from '../../../../shared/models/jobTypeCourt.model';

import { BsModalService } from 'ngx-bootstrap/modal';


import { JobServiceRule } from '../../../../shared/models/jobServiceRule.model';

import { DatePipe } from '@angular/common';
import { Location } from '@angular/common';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';
import { Project } from 'src/app/shared/models/project';
import { routes } from 'src/app/app-routing.module';
import { AppRoute } from 'src/app/shared/models/appRoute.model';
import { MysqlService } from 'src/app/services/mysql.service';
import { Clipboard } from '@angular/cdk/clipboard'; // using the clipboard

@Component({
  selector: 'app-project-admin-view',
  templateUrl: './project-admin-view.component.html',
  styleUrls: ['./project-admin-view.component.scss']
})
export class ProjectAdminViewComponent implements OnInit {



  @Input() intialCount = 221;
  @Input() count = this.intialCount;
  // sees if there is a change in myCount
@Output()
change: EventEmitter<number> = new EventEmitter<number>();
  job_type: Object;
  job_type_courts: Object;
  sent_job_type_location_id: any;
  job_type_document: Object;
  job_type_document_types: Object;
  sent_job_type_court_id: any;
  job_type_affidavit: Object;

  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  job_service_rule: Object;
  project: any;
  @Input() project_id?: number;
  brands: any;
  model: Project;
  sendTypeID: any;
  modalRef: any;
  childTitle = 'This text is passed to child';
  job_id: number;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  project_routes: any;
  model_routes: any;
  created_file_name: string;

  creating_file: number;
  project_gst: any;
  project_total: any;
  project_time_estimate: any;
  project_subtotal: number;

  constructor(
    private http: HttpClient,
    private _demoService: DemoService,
    private route: ActivatedRoute,
    private router: Router,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private modalService: BsModalService, viewRef: ViewContainerRef,
     private _location: Location,  public gfunc: GlobalFunctionsService,
     public datepipe: DatePipe,
     private _mysqlService: MysqlService,
     private clipboard: Clipboard, // ciipboard
  ) { 
// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

    this.project_id = +this.route.snapshot.paramMap.get('project_id');

    this.creating_file = 0; // creating file animation and progress
  }

  ngOnInit() {

    // just need the project ID
    this.model = new Project();
    this.getProject(this.project_id);
    this.getProjectRoutes(this.project_id)
    this.change.emit(this.intialCount);
    // this.getTraceCandidate(this.count);

  
  //  this.project_id = this.count;
  }

// ngOnChanges(){
//   this.model = new Project();
//   this.getProject(this.project);
// }

  getProject(project_id) {
    this._demoService.getProject(project_id).subscribe(
       data => { this.project = data; 
        let res = data[0];
        // this.getJob(res.job_id);
        this.job_id = res.job_id;
        console.log('JObUID:', this.job_id);

       // this.model.job_type_id = res.job_type_id;
        // this.getJobTypeLocations(res.job_type_id);
        // this.getJobTypeCourts(res.job_type_location_id);
        // this.getJobTypeDocumentTypes(res.job_type_court_id);
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }



   getProjectRoutes(project_id) {
    this._demoService.getProjectRoutes(project_id).subscribe(
       data => { this.project_routes = data; 
        let res = data[0];
        // this.getJob(res.job_id);
        // this.job_id = res.job_id;
        // console.log('JObUID:', this.job_id);

       // this.model.job_type_id = res.job_type_id;
        // this.getJobTypeLocations(res.job_type_id);
        // this.getJobTypeCourts(res.job_type_location_id);
        // this.getJobTypeDocumentTypes(res.job_type_court_id);
      
        this.doCalculations_ProjectBillingItemsTotals(this.project_routes);
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }




   // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}

 openModalScript(project_id) {
  this.sendTypeID(project_id);
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(this.templateCreate, config);
}
  templateCreate(templateCreate: any, config: { backdrop: boolean; ignoreBackdropClick: boolean; class: string; }): any {
    throw new Error('Method not implemented.');
  }

// :: Parent / Child modal test
// closeParentModel() {
//   // alert('parent component function.');
//   this.modalRef.hide();
//   this.refreshGrid(); // resets the grid if updated and closed.
// //  this.updateTypeClick = false; // closes the div
// };


   // to router navigate back
   public goBack() {
    this._location.back();
    }



// Created to test and process new paragraph templates/merge variables Live without effecting original and current systems and workflows Live.
createDocument_2023_Project(model) {
  // generate more data first
  this.creating_file = 1; // starts the file creating animation

  // Need to add the project Routes to the model. // Later we can add notes and files if post vars can handle that kind of data, then create the document with no mysql lookups.
  // :: Adds the project_routes to the model
  if(this.project_routes != null){

    // Count the routes for merge loop script
    let project_routes_count = this.project_routes.length;
    model.project_routes_count = project_routes_count;

    let full_model = {
      ...model,
      ...this.project_routes
    }
    model = full_model;
  }

  this._mysqlService.createDocument_2023_Project(model).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      // this.toastr.success('Creating Document for you now.');
      const res = data;
      // console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log('TheRespose: ' + res[0].text()); // Convert response to a string
      this.created_file_name = res[0] as string;
      // this.created_file_name = res[0].text();
      model.attached_file_name = this.created_file_name;
      this.creating_file = 0; // hides the file creating animation
     

    },
    (error) => {
    console.log(error.error);
    },
     () => console.log('What do we do next..????' + this.created_file_name)
  );
}


copyToClipboardInGrid(id) {
  // const content = document.getElementById('note_content_' + id).innerHTML; // copy all formatting.
  const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
  // const content = document.getElementById('note_content_' + id).textContent; // removes all tags and formatting
  
  this.clipboard.copy(content);
  this,this.toastr.info("Note Copied")
  // this.copyInGrid('btnTwo', id);
}

copyToClipboardInGridHTML(id) {
  const content = document.getElementById('note_content_' + id).innerHTML; // copy all formatting.
  // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
  this.clipboard.copy(content);
  this,this.toastr.info("Note Copied")
  // this.copyInGrid('btnTwo', id);
}

copyToClipboard(id) {
  const content = document.getElementById(id).innerHTML; // copy all formatting.
  // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
  this.clipboard.copy(content);
  this,this.toastr.info(" Copied")
  // this.copyInGrid('btnTwo', id);
}

copyToClipboardPlainText(id) {
  const content = document.getElementById(id).innerHTML; // copy all formatting.
  // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
  this.clipboard.copy(this.removeTags(content));
  this,this.toastr.info(" Copied")
  // this.copyInGrid('btnTwo', id);
}

        // Removes HTML from a sron
        // ::@ https://www.geeksforgeeks.org/how-to-strip-out-html-tags-from-a-string-using-javascript/
        removeTags(str) {
          if ((str===null) || (str===''))
              return false;
          else
              str = str.toString();
                
          // Regular expression to identify HTML tags in
          // the input string. Replacing the identified
          // HTML tag with a null string.
          return str.replace( /(<([^>]+)>)/ig, '');
      }



      doCalculations_ProjectBillingItemsTotals(model){

        //  this.invoice_model = this.invoiceItem;
        
          // this.invoice_tax = this.invoiceItemsList.reduce((a, b) => a += (b.tax), 0); // now calculates !!!!!! NUMBER FORMAT MISSING>>>>>
                          // this.invoice_tax = this.invoiceItemsList.reduce((a, b) => a += Number(b.tax), 0); // now calculates
                          // this.invoice_model.invoice_gst = this.invoice_tax;
                        
                          // // this.toastr.info('Calculating...');
                          // // this.invoice_total = this.invoiceItemsList.reduce((a, b) => a += (b.billing_task_fee * b.qty), 0);
                          // this.invoice_total = this.invoiceItemsList.reduce((a, b) => a += Number(b.total), 0);
                          // this.invoice_model.invoice_total = this.invoice_total + this.invoice_tax;
                          
                          // // this.invoice_total = this.invoiceItemsList.reduce((a, b) => a += (b.billing_task_fee * b.qty), 0);
                          // // this.invoice_model.invoice_total = this.invoice_total += this.invoice_tax;
                        
                          // this.invoice_subtotal = (this.invoice_total - this.invoice_tax); // 
                          // this.invoice_model.invoice_subtotal = this.invoice_subtotal;
                        
                          // this.invoice_model = this.invoiceItem;
                          // // updated by
                          // let update_user = this.sessionUserId;
                          // this.invoice_model.updated_by = this.sessionUserId;  
    
                          this.project_gst = model.reduce((a, b) => a += Number(b.app_route_gst), 0); // now calculates
                          model.project_gst = this.project_gst;
                          // this.brandForm.controls['project_gst'].setValue(this.project_gst);

                           this.project_total = model.reduce((a, b) => a += Number(b.app_route_total), 0);
                           model.project_total = this.project_total + this.project_gst;
                          // this.brandForm.controls['project_total'].setValue(this.project_total);
    
    
                          this.project_time_estimate = model.reduce((a, b) => a += Number(b.app_route_time_estimate), 0);
                          model.project_time_estimate = this.project_time_estimate;
                          // this.brandForm.controls['project_time_estimate'].setValue(this.project_time_estimate);
    
                          this.project_subtotal = (this.project_total - this.project_gst);
                          model.project_subtotal = this.project_subtotal;

                          // this.brandForm.controls['project_subtotal'].setValue(this.project_subtotal);
    
    
                        console.log('Calcuated Fugures: ' + this.project_id);
                        console.log('Project GST Fugures: $' + this.project_gst);
                        console.log('Project Total Fugures: $' + this.project_total);
                        console.log('Project subTotal Fugures: $' + this.project_subtotal);
                        console.log('Project Hours Estimate Fugures: ' + this.project_time_estimate);


                        let project_figures_model = {
                          project_id: this.project_id,
                          project_gst: this.project_gst,
                          project_total: this.project_total,
                          project_subtotal: this.project_subtotal,
                          project_time_estimate: this.project_time_estimate
                        }
                        this.updateProjectFigures(project_figures_model)
        
          }



          updateProjectFigures(model) {
            this._demoService.updateProjectFigures(model).subscribe(
               data => {
               // console.log(model);
                 // this.trace_candidate_update = data;
               this.toastr.success('Project Figures Updated');
               // Subject to reload the manager component parent.
               this.closeParentModel.emit();
               // CreateJobTypeComponent.returned.next(false);
                 return true;
               },
               error => {
                 console.error('Error Saving Project Figures!');
                 return console.error(error);
               }
              // err => console.error(err),
              // () => console.log('done updates')
            );
            }


}
